import React, { useEffect } from "react";
import ReactDOM from "react-dom";

export function Modal({
  show, // Boolean: Controls whether the modal is visible
  onClose, // Function: Callback to close the modal
  title, // String: Title for the modal
  body, // JSX/HTML: The content to display in the modal body
  footer, // JSX/HTML: Footer content (buttons, etc.)
  dialogClassName, // Optional: extra classes for modal-dialog (e.g., 'modal-lg', 'modal-xl')
}) {
  // Prevent scrolling when the modal is shown
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup on unmount or when the modal is hidden
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  // Close the modal if the user clicks on the backdrop
  // const handleBackdropClick = (e) => {
  //   if (e.target.classList.contains("modal") && onClose) {
  //     onClose();
  //   }
  // };

  if (!show) return null; // Render nothing when the modal is hidden

  // Use React portal to render the modal at the end of the body
  return ReactDOM.createPortal(
    <>
      {/* Modal */}
      <div
        className="modal show"
        style={{ display: "block" }}
        tabIndex="-1"
        // onClick={handleBackdropClick}
      >
        <div className={`modal-dialog ${dialogClassName || ""}`}>
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body">{body}</div>

            {/* Modal Footer */}
            <div className="modal-footer">{footer}</div>
          </div>
        </div>
      </div>

      {/* Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
    </>,
    document.body // Attach modal and backdrop to the end of the body
  );
}
